import { LockOutlined, Visibility, VisibilityOff } from '@mui/icons-material';
import { Avatar, Box, Button, CardContent, CardHeader, CssBaseline, Grid, IconButton, InputAdornment, LinearProgress, Paper, TextField, Typography, Card } from '@mui/material';
import { Navigate, Route, Routes, useLocation, useNavigate, } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import Grid2 from '@mui/material/Grid2';
import proxelera from '../../images/proxelera.png';
import { commons, util } from '../../commons';
import { formToObj, validateFormData } from '../../lib/validator';
import AuthService from '../../service/AuthService';
import background from "../../images/background.jpg"
import { customStyles } from "../../styles/tableStyle"

import { registerForm } from '../../schema/formSchema/signup';
import RegisterForm from './RegisterForm';


function Register(props) {
    const navigate = useNavigate();
    const [loginData, setLoginData] = useState([]);
    
    useEffect(() => {
    }, []);

    return (
        <Grid2 container spacing={2} sx={{
            justifyContent: "center",
            alignItems: "center",
            backgroundImage: `url(${background})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            width: '100vw',
            height: '100vh'
        }} >
            <CssBaseline />
            <Grid2 xs={12} md={6} lg={4} sx={{ 
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 500 
            }}>
                <Paper elevation={3} sx={{ 
                    width: '100%',
                    maxWidth: 500,
                    margin: 2,
                    borderRadius: 2
                }}>
                    <Box sx={{ 
                        padding: { xs: 3, sm: 4 },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        {/* <Box
                            component="img"
                            sx={{
                                height: { xs: 150, sm: 200, md: 233 },
                                width: { xs: 250, sm: 300, md: 350 },
                                maxHeight: { xs: 150, sm: 200, md: 233 },
                                maxWidth: { xs: 250, sm: 300, md: 350 },
                                marginBottom: 2
                            }}
                            alt="The house from the offer."
                            src={proxelera}
                        /> */}
                        <RegisterForm role={false} title="Register"/>
                    </Box>
                </Paper>
            </Grid2>
        </Grid2>
    );
}

export default Register;
